import {defaultFont} from '../initial-state';
import {getStyleAttributes, normalizeOldFontWeight, getTextStyles} from '../helper';

const renderInitialState = () => {
  return defaultFont;
};

const updateFormLabelStyles = (currentState, value, modelData) => {
  if (!modelData) {
    return currentState;
  }

  const {family, style, size, weight} = getStyleAttributes(modelData, 'label');
  const textStyles =
    modelData.safeGet('style.label.font.textStyles') ||
    getTextStyles(weight, style);
  const normalizedWeight = normalizeOldFontWeight(modelData, weight, 'label');

  return {
    ...currentState,
    family,
    size,
    style,
    weight: normalizedWeight,
    textStyles,
  };
};

const fontChange = (currentState, {family, weight, style}, modelData) => {
  modelData.set('style.label.font.family', family);
  modelData.set('style.label.font.weight', weight);
  modelData.set('style.label.font.style', style);

  return {
    ...currentState,
    family,
    weight,
    style
  };
};

const removeFont = (currentState) => {
  return {...currentState};
};

const styleChange = (currentState, styleName, modelData) => {
  const newValue = !currentState.textStyles[styleName];

  modelData.set(`style.label.font.textStyles.${styleName}`, newValue);

  return {
    ...currentState,
    textStyles: {
      ...currentState.textStyles,
      [styleName]: newValue,
    }
  };
};

export default {
  renderInitialState,
  updateFormLabelStyles,
  fontChange,
  removeFont,
  styleChange,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/form-field-label/font-actions.js